import React from "react";
import { Checkbox, CheckboxProps, ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";

type WcCheckBoxAsCheckboxProps = CheckboxProps & {
  renderAsButtons?: false;
  trueLabel?: never;
  falseLabel?: never;
};

// type WcCheckBoxAsButtonsProps = ToggleButtonGroupProps & {
type WcCheckBoxAsButtonsProps = Omit<CheckboxProps, "onChange" | "value"> & {
  renderAsButtons: true;
  trueLabel: string;
  falseLabel: string;
  value?: boolean;
  onChange?: (event: React.MouseEvent<HTMLElement>, value: boolean | null) => void;
};

export type WcCheckBoxProps = {
  controlDisabled?: boolean;
  size?: "small" | "medium";
} & (WcCheckBoxAsCheckboxProps | WcCheckBoxAsButtonsProps);

export const WcCheckBox = ({ controlDisabled = false, size = "small", sx, renderAsButtons = false, ...props }: WcCheckBoxProps) => {
  if (renderAsButtons) {
    const { trueLabel, falseLabel, onChange, value } = props as WcCheckBoxAsButtonsProps;

    const handleToggleChange = (event: React.MouseEvent<HTMLElement>, val: string | null) => {
      if (onChange) {
        const booleanValue = val === null ? null : val === "true";
        onChange(event, booleanValue);
      }
    };

    return (
      <ToggleButtonGroup
        exclusive={true}
        value={value === undefined || value === null ? null : String(value)}
        onChange={handleToggleChange}
        disabled={controlDisabled}
        sx={[{ paddingRight: 5 }, ...(Array.isArray(sx) ? sx : [sx])]}
        // {...(rest as WcCheckBoxAsButtonsProps)}
      >
        <ToggleButton
          value={"true"}
          sx={{
            minWidth: 40,
            borderRadius: 40,
            height: 35,
          }}
        >
          {trueLabel}
        </ToggleButton>
        <ToggleButton
          value={"false"}
          sx={{
            minWidth: 40,
            borderRadius: 40,
            height: 35,
          }}
        >
          {falseLabel}
        </ToggleButton>
      </ToggleButtonGroup>
    );
  }

  return (
    <Checkbox
      size={size}
      data-testid="checkbox"
      disableRipple={controlDisabled}
      disabled={controlDisabled}
      sx={[
        ({ appPalette }) => ({
          "&.Mui-disabled": {
            color: appPalette?.primary[70] ?? "inherit",
            pointerEvents: "unset",
            "&&:hover": {
              cursor: "default",
            },
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...(props as WcCheckBoxAsCheckboxProps)}
    />
  );
};

export default WcCheckBox;
